/** Путь к чату по первичному ключу клиента в CRM (`User.id`). Канал (Telegram / MAX) определяется на бэкенде. */
export function getChatPath(crmUserId, returnTo = "/chat") {
  const path = `/chat/${encodeURIComponent(String(crmUserId))}`;
  return returnTo ? `${path}?return_to=${encodeURIComponent(returnTo)}` : path;
}
